module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-Book.6c5c03ae.eot";